<template>
  <v-data-table
        :headers="headers"
        :items="medicamentos"
        :sort-desc="[false, true]"
        :items-per-page="5"
        multi-sort
        class="elevation-0 border"
      ></v-data-table>
</template>

<script>
export default {
  name: "TablaMedicamentos",

  data: () => ({
    headers: [
      { text: "", value: "COD_MED" },
      { text: "MEDICAMENTOS", value: "NOMBRE_COMPLETO" },
      { text: "CONS", value: "CONSUMO" },
      { text: "STOCK", value: "STOCK" },
    ],
  }),
  props: ["medicamentos"],
};
</script>